export const LoginRoutesConst = {
  LoginLayout: "LoginLayout",
  Dashboard: "Dashboard",
  TaskHelpingResult: "TaskHelpingResult",
  UseForme: "UseForme",
  AddFirstKid: "AddFirstKid",
  AddAdditionalKid: "AddAdditionalKid",
  MyKid: "MyKid",
  MyKidReport: "MyKidReport",
  MyPage: "MyPage",
  AccountManagement: "AccountManagement",
  DeleteKid: "DeleteKid",
  MyKidContent: "MyKidContent",
  PatchKid: "PatchKid",
  ExtensionCode: "ExtensionCode",
  RegisterCode: "RegisterCode",
  CallbackExtensionCode: "CallbackExtensionCode",
  CancelExtensionCode: "CancelExtensionCode",
  MyKidSurvey: "MyKidSurvey",
  HowToUse: "HowToUse",
  MyKidPromise: "MyKidPromise",
  MyKidState: "MyKidState",
  BillingHistory: "BillingHistory",
} as const;

export const LogoutRoutesConst = {
  Walkthrough: "Walkthrough",
  LogoutLayout: "LogoutLayout",
  SignIn: "SignIn",
} as const;

export const CommonRoutesConst = {
  Policy: "Policy",
  Exit: "Exit",
} as const;

export const StepParamConst = {
  kidInfo: "kidInfo",
  license: "license",
  qrcode: "qrcode",
} as const;

export type BeforeStartType = "Dashboard" | "UseForme" | "MyKid";

export type SurveyQuestionType = {
  index: number;
  category: string;
  question: string;
};

export type SelectWeekParentType =
  | "UseForme"
  | "SchoolPreparation"
  | "BehaviorEvaluation";

export type BehaviorEvaluationType = "selfControl" | "mood" | "metaCognitive";
export type SchoolPreparationType = "schoolPreparation";
export type KidReportCategoryType = Partial<
  BehaviorEvaluationType | SchoolPreparationType
>;

export type SelfControlFeatureType =
  | "Achievement"
  | "Responsibility"
  | "Attention";

export type MoodFeatureType = "Sadness" | "Anger" | "Resilience";

export type MetaCognitiveFeatureType = "Mindful" | "Monitoring" | "Neat";

//todo
export type PreparationType = "temp";

export type MyKidReportFeatureDetailType = {
  key: string;
  title: string;
  content: string;
  avg?: number;
};

export type MyKidReportContentsConstType = {
  selfControl: Record<SelfControlFeatureType, MyKidReportFeatureDetailType>;
  mood: Record<MoodFeatureType, MyKidReportFeatureDetailType>;
  metaCognitive: Record<MetaCognitiveFeatureType, MyKidReportFeatureDetailType>;
  schoolPreparation: Record<"data", MyKidReportFeatureDetailType>;
};

export type CntTaskType = "total" | "magicBall" | "magicPotion" | "magicGift";
